import { render, staticRenderFns } from "./edit-form-item.vue?vue&type=template&id=f694f0dc&"
import script from "./edit-form-item.vue?vue&type=script&lang=ts&"
export * from "./edit-form-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports